module.exports = __webpack_public_path__ + "static/img/4220480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/miniProgram.jpg
// module id = 102
// module chunks = 2